module.exports = __webpack_public_path__ + "static/media/login.c9f39d1b.jpg";